import { iconLibrary } from './icon.helper';
import { LazyIcon } from '@photosi/rn-components/lazy-icon/LazyIcon';
import { IconProps } from './Icon.types';

export const Icon = (props: IconProps) => {
  return <LazyIcon iconLibrary={iconLibrary} {...props} />;
};
